import { render, staticRenderFns } from "./TabSunriseSunset.vue?vue&type=template&id=148fbadc&scoped=true"
import script from "./TabSunriseSunset.vue?vue&type=script&lang=js"
export * from "./TabSunriseSunset.vue?vue&type=script&lang=js"
import style0 from "./TabSunriseSunset.vue?vue&type=style&index=0&id=148fbadc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148fbadc",
  null
  
)

export default component.exports